import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

/* A grid rather than a `<Flex />`: equal thirds need `flex: 1 1 0` per child, which `Flex.Item`
   deliberately does not expose, and `flex-basis: auto` would size the totals by their labels. */
export const ImportedInvoiceReviewTotalsWrapper = styled.div`
  display: grid;
  gap: ${Spacing.S12};
  grid-template-columns: repeat(3, minmax(0, 1fr));
`
